module.exports = __webpack_public_path__ + "img/footer.c06ba8c8.jpg";